export const DISPLAY_MIN_WIDTH = 320;
export const DISPLAY_MAX_WIDTH = 480;
export const DISPLAY_DESKTOP = 0;
export const DISPLAY_MOBILE = 0;
export const SPLASH_IMAGE_START = '30%';
export const SPLASH_IMAGE_END = '50%';
